import { render, staticRenderFns } from "./top-slider.vue?vue&type=template&id=1338bd48&"
import script from "./top-slider.vue?vue&type=script&lang=js&"
export * from "./top-slider.vue?vue&type=script&lang=js&"
import style0 from "./top-slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports